// @core/api/endpoints/knowledge/retrieve.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetrieveRequest,
  RetrieveResponse,
} from '../../../types/knowledge';

const BASE_PATH = '/knowledge';

/**
 * Retrieve chunks
 * Embeds the query and returns the top-k most similar chunks from the knowledge base. This is the retrieval half of RAG; feed the chunks to an LLM step for the generation half.
 */
export async function Retrieve(
  base_id: string,
  data: RetrieveRequest,
  options?: RequestOptions
): Promise<RetrieveResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id/retrieve`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.post<RetrieveResponse>(requestPath, data, requestOptions);
}
